module.exports = __webpack_public_path__ + "static/media/heartrate.61314be8.jpeg";